module.exports = __webpack_public_path__ + "static/img/pic_top@2x.fd6bff25.png";